<script lang="ts"></script>

<div id="dateModal"></div>

<style
    lang="less"
    global
>
    #dateModal {
        position: absolute;
        z-index: 9999;
        background-color: white;
        display: none;
    }

    #dateDeleteValidationModal {
        position: absolute;
        z-index: 9999;
        background-color: white;
        display: none;
        flex-direction: column;
        gap: 10px;
        padding: 0.6rem;
        width: 236px;
        .question {
            padding: 0px;
            margin: 0px;
            font-size: 0.6rem;
        }
        .bottom {
            display: flex;
            justify-content: space-between;
            .cancel,
            .delete {
                padding: 0px;

                cursor: pointer;
                background-color: transparent;
                border: none;
                font-size: 0.6rem;
            }
            .cancel {
                color: var(--stategrey);
            }
            .delete {
                color: var(--renzrot);
            }
        }
    }
</style>
